var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kendo-date-picker',{attrs:{"value":_vm.dateValue,"format":'MMMM yyyy',"inputFormat":'MM/yyyy',"label":_vm.translate(_vm.label),"min":_vm.minLimitDate,"max":_vm.maxLimitDate,"required":true,"depth":'year'},on:{"change":_vm.emitNewValue}})}
var staticRenderFns = []

export { render, staticRenderFns }